import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { TaxInfoAudit, TaxInfoSkeleton } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-tax-info-audit-list',
  templateUrl: './person-profile-tax-info-audit-list.component.html',
  styleUrls: ['./person-profile-tax-info-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileTaxInfoAuditListComponent implements OnInit {
  @Input() taxInfo: TaxInfoSkeleton;
  @Input() loading: boolean;
  @Input() taxInfoAudits: TaxInfoAudit[];

  @Output() loadTaxInfoAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadTaxInfoAudits.emit(this.taxInfo.taxInfoId);
  }

  onNextPage() {
    this.nextPage.emit(this.taxInfo.taxInfoId);
  }
}
